import React from "react";
import { IconProps } from "../icon";
import { createIcon } from "../util/create-icon";
// import "../style/css";

const AddCircleIcon: React.ForwardRefExoticComponent<
  IconProps & React.RefAttributes<SVGSVGElement>
> = /*#__PURE__*/ createIcon(
  "add-circle",
  "AddCircleIcon",
  ["currentColor","white"],
  (colorList) => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="none"><g clipPath="url(#clip0_19498_558)"><path d="M8.00016 14C11.3139 14 14.0002 11.3137 14.0002 7.99998C14.0002 4.68627 11.3139 1.99998 8.00016 1.99998C4.68646 1.99998 2.00016 4.68627 2.00016 7.99998C2.00016 11.3137 4.68645 14 8.00016 14ZM15.3335 7.99998C15.3335 12.0501 12.0503 15.3333 8.00016 15.3333C3.95008 15.3333 0.66683 12.0501 0.666831 7.99998C0.666831 3.94989 3.95008 0.666646 8.00016 0.666646C12.0503 0.666647 15.3335 3.94989 15.3335 7.99998ZM7.3335 11.3333L7.3335 8.66665L4.66683 8.66665L4.66683 7.33331L7.3335 7.33331L7.3335 4.66665L8.66683 4.66665L8.66683 7.33331L11.3335 7.33331L11.3335 8.66665L8.66683 8.66665L8.66683 11.3333L7.3335 11.3333Z" fill={colorList[0]} fillRule="evenodd" clipRule="evenodd" fillOpacity="0.9"/></g><defs><clipPath id="clip0_19498_558"><rect width="16" height="16" fill={colorList[1]}/></clipPath></defs></g></svg>
);

export default AddCircleIcon;
